module.exports = __webpack_public_path__ + "img/logo-aiTongChuan-light-mode.121a5b9f.svg";